import { jsx as n, jsxs as g } from "react/jsx-runtime";
import { css as u, keyframes as w, cx as E } from "@emotion/css";
import { forwardRef as L, useState as _, useRef as y, useEffect as x } from "react";
import { CSSTransition as $ } from "react-transition-group";
const A = ({ cx: e, getStyles: o }) => /* @__PURE__ */ n("div", { className: e("spinner", u(o("spinner"))), children: /* @__PURE__ */ n("svg", { viewBox: "25 25 50 50", children: /* @__PURE__ */ n(
  "circle",
  {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }
) }) }), D = w`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, T = w`
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -124px;
  }
`, f = {
  wrapper: (e) => ({
    position: "relative",
    ...e
  }),
  overlay(e, o) {
    return {
      position: "absolute",
      height: "100%",
      width: "100%",
      top: "0px",
      left: "0px",
      display: "flex",
      textAlign: "center",
      fontSize: "1.2em",
      color: "#FFF",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 800,
      transition: `opacity ${(o == null ? void 0 : o.fadeSpeed) ?? 500}ms ease-in`,
      opacity: ["entering", "entered"].includes(e) ? 1 : 0
    };
  },
  content: () => ({
    margin: "auto"
  }),
  spinner: () => ({
    position: "relative",
    margin: "0px auto 10px auto",
    width: "50px",
    maxHeight: "100%",
    "&:before": {
      content: '""',
      display: "block",
      paddingTop: "100%"
    },
    "& svg": {
      animation: `${D} 2s linear infinite`,
      height: "100%",
      transformOrigin: "center center",
      width: "100%",
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      margin: "auto",
      "& circle": {
        animation: `${T} 1.5s ease-in-out infinite`,
        strokeDasharray: "1,200",
        strokeDashoffset: 0,
        strokeLinecap: "round",
        stroke: "#FFF"
      }
    }
  })
}, j = (e) => {
  const {
    innerRef: o,
    children: S,
    className: k,
    onClick: b,
    spinner: m = !0,
    fadeSpeed: C = 500,
    active: a = !0,
    styles: v = {},
    classNamePrefix: N = "_loading_overlay_",
    text: F
  } = e, [R, O] = _(
    void 0
  ), s = y(null), h = y(null), d = (t, ...c) => {
    const i = Array.isArray(t) ? t : [t];
    return E(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      i.map(
        (r) => typeof r == "string" ? `${N}${r}` : ""
      ),
      ...c
    );
  }, p = (t, c) => {
    var l;
    const i = (l = f == null ? void 0 : f[t]) == null ? void 0 : l.call(f, c, e), r = (v == null ? void 0 : v[t]) ?? !1;
    return r ? typeof r == "function" ? r(i, e) : r : i;
  };
  return x(() => {
    var t;
    if (s.current = ((t = h.current) == null ? void 0 : t.parentElement) ?? null, s.current !== null) {
      const c = window.getComputedStyle(s.current), i = ["overflow", "overflowX", "overflowY"].reduce((r, l) => (c[l] !== "visible" && (r[l] = "hidden"), r), {});
      O(i);
    }
  }, []), x(() => {
    a && s.current && (s.current.scrollTop = 0);
  }, [a]), /* @__PURE__ */ g(
    "div",
    {
      "data-testid": "wrapper",
      ref: o,
      className: d(
        ["wrapper", a && "wrapper--active"],
        u(
          p(
            "wrapper",
            a ? R : void 0
          )
        ),
        k
      ),
      children: [
        /* @__PURE__ */ n(
          $,
          {
            in: a,
            classNames: "_loading-overlay-transition",
            timeout: C,
            unmountOnExit: !0,
            nodeRef: h,
            children: (t) => (
              // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
              /* @__PURE__ */ n(
                "div",
                {
                  ref: h,
                  "data-testid": "overlay",
                  className: d(
                    "overlay",
                    u(p("overlay", t))
                  ),
                  onClick: b,
                  children: /* @__PURE__ */ g(
                    "div",
                    {
                      className: d(
                        "content",
                        u(p("content"))
                      ),
                      children: [
                        m && (typeof m == "boolean" ? /* @__PURE__ */ n(
                          A,
                          {
                            cx: d,
                            getStyles: p
                          }
                        ) : m),
                        F
                      ]
                    }
                  )
                }
              )
            )
          }
        ),
        S
      ]
    }
  );
}, M = L(
  (e, o) => /* @__PURE__ */ n(j, { innerRef: o, ...e })
);
export {
  M as L
};
//# sourceMappingURL=LoadingOverlay-bGR7yg6p.js.map
